declare global {
  interface Window {
    savedConcurrencyObject: any;
  }
}

export function getSavedConcurrencyObject() {
  return window.savedConcurrencyObject;
}

export function setSavedConcurrencyObject(concurrencyObject: any) {
  window.savedConcurrencyObject = concurrencyObject;
}
